import { SxProps } from '@mui/material';
import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';

const container: SxProps = {
  flex: 1,
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  paddingTop: GLOBAL_MARGIN_HORIZONTAL,
  paddingBottom: GLOBAL_MARGIN_HORIZONTAL,
  paddingRight: GLOBAL_MARGIN_HORIZONTAL * 2,
  paddingLeft: GLOBAL_MARGIN_HORIZONTAL * 2,
};

export { container };
